<div class="text-center">
  @if (withTitle()) {
    <h1 class="text-4xl uppercase">
      <ng-content select="[title]" />
    </h1>
  }

  <app-ornamental-divider />

  @if (withSubtitle()) {
    <div class="tracking-[0.375rem] uppercase">
      <ng-content select="[subtitle]" />
    </div>
  }
</div>
